<i18n>
{
  "en": {
    "productSearch": "Search by name",
    "isManaged": "Filter by revenue management",
    "isNew": "Filter by new",
    "all": "All",
    "yes": "Yes",
    "no": "No"
  },
  "es": {
    "productSearch": "Buscar por nombre",
    "isManaged": "Filtrar por gestión de ingresos",
    "isNew": "Filtrar por nuevo",
    "all": "Todos",
    "yes": "Si",
    "no": "No"
  }
}
</i18n>

<template>
<v-row>
  <v-col class="d-flex" cols="12" md="6" lg="6" xl="6">
    <v-text-field :placeholder="$t('productSearch')" :disabled="disabled" @input="onFinishTyping">
    </v-text-field>
  </v-col>
  <v-col class="d-flex mt-lg-4 mt-md-4" cols="6" sm="3">
    <v-select v-model="selectedManaged" :items="selectorBooleanTags" :label="this.$t('isManaged')"
              :disabled="disabled"
              dense hide-details @change="onSelectManaged"/>
  </v-col>
  <v-col class="d-flex mt-lg-4 mt-md-4" cols="6" sm="3">
    <v-select v-model="selectedNew" :items="selectorBooleanTags" :label="this.$t('isNew')" :disabled="disabled"
              dense hide-details @change="onSelectNew"/>
  </v-col>
</v-row>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class MasterProductFilter extends Vue {
  @Prop({ type: Boolean, default: false }) disabled;

  selectedManaged = 'all';

  selectedNew = 'all';

  get selectorBooleanTags() {
    return [
      { text: this.$t('all'), value: 'all' },
      { text: this.$t('yes'), value: 'yes' },
      { text: this.$t('no'), value: 'no' }
    ];
  }

  onFinishTyping(emitted) {
    this.$emit('product', emitted);
  }

  onSelectManaged(emitted) {
    this.$emit('managed', emitted);
  }

  onSelectNew(emitted) {
    this.$emit('new', emitted);
  }
}

</script>
